import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-confirm-dialog-csi',
  templateUrl: './confirm-dialog-csi.component.html',
  styleUrls: ['./confirm-dialog-csi.component.css']
})
export class ConfirmDialogCsiComponent implements OnInit {

  @Input() key;
  @Input() titulo: string;
  @Input() width;
  @Output() accept = new EventEmitter<any>();
  @Output() reject = new EventEmitter<any>();

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/commons/ui/confirm-dialog-csi/confirm-dialog-csi.component.ts